import { render, staticRenderFns } from "./emoji-key.vue?vue&type=template&id=6c372902&scoped=true&lang=pug&"
import script from "./emoji-key.vue?vue&type=script&lang=ts&"
export * from "./emoji-key.vue?vue&type=script&lang=ts&"
import style0 from "./emoji-key.vue?vue&type=style&index=0&id=6c372902&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c372902",
  null
  
)

export default component.exports